// extracted by mini-css-extract-plugin
export var labelWrapper = "_du-0";